import initHelpCenter from './init-help-center';

export default {
  initHelpCenter,
};
